import React from 'react'
import createMarkup from '../../../helpers/createMarkup'
import { Row, Col, Button } from 'reactstrap'

export default function ItemAnswer (props) {
  let markup
  let output = <div></div>
  if (props.answer) {
    markup = createMarkup(props.answer.answer)
    output = <div dangerouslySetInnerHTML={markup}></div>
  }

  let color = 'secondary'
  if (props.active) {
    color = 'primary'
  }
  if (props.completed) {
    props.answer.correct
    ? color = 'success'
    : color = 'danger'
  }


  // itemQuestion props: active, choice, answer

  let button = (
    <Button 
      outline={!props.active} 
      className='btn-block' 
      color={color}
      disabled={props.completed}
      onClick={() => {props.selectAnswer(props.answer.key)}}
    >
      {` ${props.choice} `}
    </Button>)




  return (
    <Row>
      <Col xs='4' md='3' lg='2'>{button}</Col>
      <Col xs='8' md='9' lg='10'><div dangerouslySetInnerHTML={markup}></div></Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentItemView/ItemAnswer.js